import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseParamsService } from '@app/core/base-params.service';
import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { Game } from '@app/games/model/game';
import { environment } from '@env/environment';
import { LOCALE_HEADER, LOYALTY_CLUB_SLUG_HEADER } from '@app/core/consts';

@Injectable()
export class GamesApiService {
  private http = inject(HttpClient);
  private baseParamsService = inject(BaseParamsService);


  public getList(language: string): Observable<Game[]> {

    return this.http.get<Record<string, Game[]>>(
      `${environment.webforms_api}/v1/members/me/games`,
      { headers: this.prepareHeaders(language) },
    ).pipe(
      retry(3),
      map((response: Record<string, Game[]>) => response?.games || []),
    );
  }

  private prepareHeaders(language: string): HttpHeaders {
    let headers = this.baseParamsService.getAuthHeadersWithAutologin() || new HttpHeaders();
    headers = headers.set(LOYALTY_CLUB_SLUG_HEADER, this.baseParamsService.slug);
    headers = headers.set(LOCALE_HEADER, language);
    return headers;
  }
}
